const { doAction, fail, success } = require('./index');
const { doFlash } = require('./flash');

const FAILED_CREATE_MESSAGE = 'Failed to create a new district';
const SUCCEEDED_CREATE_MESSAGE = 'District created';
const CREATED_DISTRICT = 'CREATED_DISTRICT';
const CREATING_DISTRICT = 'CREATING_DISTRICT';

const FAILED_DELETE_MESSAGE = 'Deletion failed';
const SUCCEEDED_DELETE_MESSAGE = 'District deleted';
const DELETED_DISTRICT = 'DELETED_DISTRICT';
const DELETING_DISTRICT = 'DELETING_DISTRICT';

const FAILED_FETCH_MESSAGE =
	'Failed to retrieve the list of districts from the server';
const FETCHED_DISTRICTS = 'FETCHED_DISTRICTS';
const FETCHING_DISTRICTS = 'FETCHING_DISTRICTS';

const SELECT_DISTRICT = 'SELECT_DISTRICT';

const FAILED_UPDATE_MESSAGE = 'Update failed';
const SUCCEEDED_UPDATE_MESSAGE = 'District updated';
const UPDATED_DISTRICT = 'UPDATED_DISTRICT';
const UPDATING_DISTRICT = 'UPDATING_DISTRICT';

module.exports = {
	FAILED_CREATE_MESSAGE,
	CREATED_DISTRICT,
	CREATING_DISTRICT,

	FAILED_DELETE_MESSAGE,
	DELETED_DISTRICT,
	DELETING_DISTRICT,

	FAILED_FETCH_MESSAGE,
	FETCHED_DISTRICTS,
	FETCHING_DISTRICTS,

	SELECT_DISTRICT,

	FAILED_UPDATE_MESSAGE,
	UPDATED_DISTRICT,
	UPDATING_DISTRICT,

	createDistrict(district) {
		const url = '/api/districts';
		const method = 'post';
		const payload = district;
		const doingActionType = CREATING_DISTRICT;
		const didActionType = CREATED_DISTRICT;
		const failureMessage = FAILED_CREATE_MESSAGE;
		const successMessage = SUCCEEDED_CREATE_MESSAGE;

		return doAction(
			url,
			method,
			payload,
			doingActionType,
			didActionType,
			failureMessage,
			successMessage
		);
	},

	deleteDistrict(districtId) {
		const url = `/api/districts/${ districtId }`;
		const method = 'delete';
		const payload = { id: districtId };
		const doingActionType = DELETING_DISTRICT;
		const didActionType = DELETED_DISTRICT;
		const failureMessage = FAILED_DELETE_MESSAGE;
		const successMessage = SUCCEEDED_DELETE_MESSAGE;

		return doAction(
			url,
			method,
			payload,
			doingActionType,
			didActionType,
			failureMessage,
			successMessage
		);
	},

	fetchDistricts() {
		const url = '/api/districts';
		const method = 'get';
		const payload = null;
		const doingActionType = FETCHING_DISTRICTS;
		const didActionType = FETCHED_DISTRICTS;
		const failureMessage = FAILED_FETCH_MESSAGE;

		return doAction(
			url,
			method,
			payload,
			doingActionType,
			didActionType,
			failureMessage
		);
	},

	selectDistrict(district) {
		return {
			type: SELECT_DISTRICT,
			payload: {
				district
			}
		};
	},

	updateDistrict(district) {
		const url = `/api/districts/${ district.id }`;
		const method = 'PATCH';
		const payload = district;
		const doingActionType = UPDATING_DISTRICT;
		const didActionType = UPDATED_DISTRICT;
		const failureMessage = FAILED_UPDATE_MESSAGE;
		const successMessage = SUCCEEDED_UPDATE_MESSAGE;

		return doAction(
			url,
			method,
			payload,
			doingActionType,
			didActionType,
			failureMessage,
			successMessage
		);
	}
};



// WEBPACK FOOTER //
// ./frontend/a2i/js/actions/districts.js